import icons from "src/design-system/icons";

// Brand side of the logged-out screens (login, forgot password): heading, line and the four benefit
// cards (wording approved by Mohsin, 29 Oct). One source, so both screens say the same thing.
export const AUTH_BRAND_MARK = "GymRite by BMS";
/** Split for the teal wordmark: name strong, suffix softer. */
export const AUTH_BRAND_MARK_NAME = "GymRite";
export const AUTH_BRAND_MARK_SUFFIX = "by BMS";
export const AUTH_BRAND_HEADING = "Train smarter, every day";
export const AUTH_BRAND_DESCRIPTION =
  "Your programmes, check-ins, progress and coach — all in one place.";
export const AUTH_BRAND_HIGHLIGHTS = [
  {
    icon: icons.calendar,
    title: "Programmes",
    text: "Workouts and meal plans for every day",
  },
  {
    icon: icons.journey,
    title: "Journeys",
    text: "Check-ins that keep you on track",
  },
  {
    icon: icons.weight,
    title: "Progress",
    text: "Weight, measurements and coins at a glance",
  },
  {
    icon: icons.people,
    title: "Community",
    text: "Your coach and gym friends, one tap away",
  },
];
